import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor( private toaster: ToastrService) { }

  /** Toaster Notification for success. */
  success(msg: string, title: string) {
    this.toaster.success(msg, title, {
      timeOut: 2000,
      closeButton: true,
      tapToDismiss: true
  });
  }

  /** Toaster Notification for error. */
  error(msg: string, title: string) {
    this.toaster.error(msg, title, {
      timeOut: 3700,
      closeButton: true,
      tapToDismiss: true
  });
  }

  /** Toaster Notification for warning. */
  warning(msg: string, title: string) {
    this.toaster.warning(msg, title, {
      timeOut: 2500,
      closeButton: true,
      tapToDismiss: true
    });
  }

  /** Toaster Notification for info. */
  info(msg: string, title: string) {
    this.toaster.info(msg, title, {
      timeOut: 2500,
      closeButton: true,
      tapToDismiss: true
    });
  }
  infoAlways(msg: string, title: string) {
    this.toaster.info(msg, title, {
      timeOut: 100000,
      closeButton: true,
      tapToDismiss: true
    });
  }
}
